import React, { useState} from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/semantic-ui.css'
import es from 'react-phone-input-2/lang/es.json'

const InputNumber = () => {
    const [value, setValue] = useState()
    const inputNumber = (
            <PhoneInput
                placeholder=""
                value={value}
                onChange={setValue}
                localization={es}
                country={"pe"}
            />
    )
    return {
        get: value,
        inputNumber,
        set: setValue,
    }
}
export default InputNumber
